import * as actionTypes from "./actionTypes";

export const openModal = (errorMessage) => {
  return {
    type: actionTypes.OPEN_MODAL,
    payload: {
      openModal: true,
      errorMessage: errorMessage,
    },
  };
};

export const closeModal = () => {
  return {
    type: actionTypes.CLOSE_MODAL,
    payload: {
      openModal: false,
    },
  };
};

export const openMessageModal = (message) => {
  return {
    type: actionTypes.OPEN_MESSAGE_MODAL,
    payload: {
      isMessage: true,
      message: message,
    },
  };
};

export const closeMessageModal = () => {
  return {
    type: actionTypes.CLOSE_MESSAGE_MODAL,
    payload: {
      isMessage: false,
    },
  };
};

export const confirmMessageModal = (message) => {
  return {
    type: actionTypes.CONFIRM_MESSAGE_MODAL,
    payload: {
      isConfirm: true,
      confirmMessage: message,
    },
  };
};

export const closeConfirmMessageModal = () => {
  return {
    type: actionTypes.CLOSE_CONFIRM_MESSAGE_MODAL,
    payload: {
      isConfirm: false,
    },
  };
};